import { Link } from "react-router-dom";
import { useAnim, useSEO } from "../hooks.jsx";
import { PAGE_SEO, BREADCRUMBS, BREADCRUMB_ITEMS, COMPANY, SITE_URL } from "../data.js";
import Breadcrumb from "../components/Breadcrumb.jsx";
import CtaBand from "../components/CtaBand.jsx";

const COSA_FACCIAMO = [
  {
    t: "Cos'è NoleggioinCloud",
    d: "NoleggioinCloud è un gestionale in cloud pensato per autonoleggi e motonoleggi italiani. In un unico pannello gestisci flotta, prenotazioni, clienti e contratti, e ottieni un sito web dove i clienti prenotano e pagano online.",
  },
  {
    t: "Per chi è",
    d: "Per chi noleggia auto e moto e vuole smettere di gestire tutto con Excel e WhatsApp: dalle piccole attività con pochi veicoli alle realtà con una flotta più ampia.",
  },
  {
    t: "Cosa include",
    d: "Sito di prenotazione, calendario delle disponibilità in tempo reale, pagamenti con Stripe, contratti PDF generati in automatico e comunicazione dei contratti alla Polizia di Stato tramite CaRGOS.",
  },
];

const PRINCIPI = [
  "Prezzi pubblici e piani chiari, con prova gratuita di 14 giorni senza carta di credito",
  "Dati ospitati su infrastruttura Google Firebase e pagamenti gestiti da Stripe",
  "Pensato per le regole italiane del noleggio, non adattato da un prodotto generico",
  "Assistenza diretta: telefono e WhatsApp, non solo ticket",
];

export default function ChiSiamo() {
  useAnim();

  const hasAddress = COMPANY.street && COMPANY.city;

  useSEO({
    ...PAGE_SEO["chi-siamo"],
    schema: [
      BREADCRUMBS["chi-siamo"],
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "Chi siamo — NoleggioinCloud",
        "url": `${SITE_URL}/chi-siamo`,
        "inLanguage": "it",
        "about": { "@type": "Organization", "name": "NoleggioinCloud", "url": SITE_URL },
      },
    ],
  });

  return (
    <>
      <Breadcrumb items={BREADCRUMB_ITEMS["chi-siamo"]} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Chi siamo</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Il gestionale per <mark>autonoleggi e motonoleggi</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            Chi è NoleggioinCloud, cosa fa e come puoi contattarci.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          {COSA_FACCIAMO.map((d) => (
            <div key={d.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{d.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{d.d}</p>
            </div>
          ))}

          <div className="an" style={{ margin: "2.25rem 0", padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".6rem" }}>Come lavoriamo</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 1.85 }}>
              {PRINCIPI.map((p) => <li key={p}>{p}</li>)}
            </ul>
          </div>

          <div className="an" style={{ marginBottom: "1.75rem" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>Dati aziendali e contatti</h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.85 }}>
              <strong>Sito:</strong> {SITE_URL.replace("https://", "")}<br />
              {COMPANY.legalName && <><strong>Ragione sociale:</strong> {COMPANY.legalName}<br /></>}
              {COMPANY.vatId && <><strong>P.IVA:</strong> {COMPANY.vatId}<br /></>}
              {hasAddress && (
                <><strong>Sede:</strong> {COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}
                {COMPANY.region ? ` (${COMPANY.region})` : ""}<br /></>
              )}
              <strong>Telefono e WhatsApp:</strong>{" "}
              <a href="tel:+393516234175">+39 351 623 4175</a><br />
              <strong>Scrivici:</strong> <Link to="/contatti">pagina contatti</Link>
            </p>
          </div>

          <div className="an">
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Per saperne di più</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              <li><Link to="/funzionalita">Funzionalità</Link></li>
              <li><Link to="/prezzi">Prezzi e piani</Link></li>
              <li><Link to="/tutorial">Tutorial video</Link></li>
              <li><Link to="/faq">Domande frequenti</Link></li>
            </ul>
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
